import React, { useEffect, useState } from "react";
import { compose } from "recompose";

import { Button, withStyles } from "@material-ui/core";
import PropTypes from "prop-types";
import CircularProgress from "@material-ui/core/CircularProgress";
import { getToken } from "../../../../../../../config/sessionData";
import { tokenIdentifier } from "../../../../../../../utils/staticData";
import instance from "../../../../../../../config/axiosConfig";
import { carsDamageImageUrl } from "../../../../../../../config/routes";

const useStyles = () => ({
  damageWrapper: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start"
  },
  damageImageWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: 62,
    width: 62,
    backgroundColor: "#43425D",
    borderRadius: "8px"
  },
  damageImage: {
    maxHeight: "100%",
    maxWidth: "100%",
    cursor: "pointer",
  },
  damageHiddenInput: {
    display: "none",
  },
  damageImageViewer: {
    position: "fixed",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    background: "rgba(0, 0, 0, 0.6)",
    zIndex: "10000",
  },
  damageImageViewerContent: {
    position: "fixed",
    maxWidth: "90%",
    maxHeight: "90%",
    top: "50%",
    left: "50%",
    transform: "translate(-50%,-50%)",
  },
  damageImageViewerCloseButton: {
    position: "fixed",
    top: "15px",
    right: "16px",
    color: "white"
  }
});

const CarDamageImage = ({ damage, classes, onDamageImageChange }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [image, setImage] = useState("");
  const [isViewOpen, setIsViewOpen] = useState(false);

  useEffect(() => {
    if (damage.obraz_id) {
      setIsLoading(true);
      let token = getToken();
      let config = {
        headers: { [tokenIdentifier]: token },
        params: { obraz_id: damage.obraz_id }
      };

      instance
        .get(carsDamageImageUrl, config)
        .then((response) => {
          setImage(response.data[1].obraz_b64);
          setIsLoading(false);
        });

    }
  }, []);

  const fileSizeToBig = (size) => {
    const tmp10Mb = 10000000;
    console.log("size", size, tmp10Mb);
    return (size > tmp10Mb);
  };

  const validateFile = (file) => {
    const validTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/x-icon'];

    if (fileSizeToBig(file.size)) {
      alert("Plik możę mieć maksymalnie 10Mb.");
      return false;
    }

    if (validTypes.indexOf(file.type) === -1) {
      alert("Tylko plik obrazu może być dodany.");
      return false;
    }


    return true;
  };

  const onDeleteFile = (damage) => {
    // let token = getToken();
    // let config = {
    //   headers: { [tokenIdentifier]: token },
    //   params: { obraz_id: damage.obraz_id }
    // };
    setImage("");
    // instance
    //   .delete(carsDamageImageUrl, config)
    //   .then(() => {
    onDamageImageChange({ ...damage, obraz_id: "" });
    //
    //     setIsLoading(false);
    //   });
  };

  const fileChangeHandler = (event) => {
    const file = event.target.files[0];
    if (validateFile(file)) {
      readAndUploadFile(file);
    }
  };

  const readAndUploadFile = (file) => {
    setIsLoading(true);
    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = (e) => {
      let base = "";
      const tmp = e.target.result;

      if (tmp) {
        const idx = tmp.indexOf(";");
        if (idx === -1) {
          base = tmp;
        } else {
          base = tmp.slice(23);
        }
      }


      let token = getToken();
      let config = {
        headers: { [tokenIdentifier]: token },
      };

      instance
        .post(carsDamageImageUrl, { obraz_b64: base }, config)
        .then(response => {
          onDamageImageChange({ ...damage, obraz_id: response.data[1].obraz_id });
          setImage(base);
          setIsLoading(false);
        })
        .catch(() => {
          setIsLoading(false);
      });
    };
  };

  const dragOver = (e) => {
    e.target.style.border = '3px dashed green';
    e.target.style.cursor = 'grabbing';
    e.preventDefault();
  };

  const dragEnter = (e) => {
    e.target.style.border = '3px dashed green';
    e.target.style.cursor = 'grabbing';
    e.preventDefault();
  };

  const dragLeave = (e) => {
    e.target.style.border = 'none';
    e.target.style.cursor = 'default';
    e.preventDefault();
  };

  const fileDrop = (e) => {
    e.target.style.border = 'none';
    e.target.style.cursor = 'default';

    const file = e.dataTransfer.files[0];
    if (validateFile(file)) {
      readAndUploadFile(file);
    }
    e.preventDefault();
  };

  const onAddFileButtonClick = (name) => {
    document.getElementById(name).click();
  };


  return (
    <div className={classes.damageWrapper}>
      <div
        className={classes.damageImageWrapper}
        onDragOver={dragOver}
        onDragEnter={dragEnter}
        onDragLeave={dragLeave}
        onDrop={fileDrop}
      >
        {isLoading ?
          <CircularProgress/> :
          <img src={"data:image/jpeg;base64," + image} alt="" className={classes.damageImage}
               onClick={() => setIsViewOpen(true)}/>
        }
      </div>
      {damage.obraz_id ?
        <>
          <Button onClick={() => onAddFileButtonClick(damage.nazwa)}>Zmień</Button> :
          <Button onClick={() => onDeleteFile(damage)}>Usuń</Button>
        </> :
        <Button onClick={() => onAddFileButtonClick(damage.nazwa)}>Dodaj</Button>
      }
      <input id={damage.nazwa} className={classes.damageHiddenInput} type="file" name="file"
             onChange={fileChangeHandler}/>

      {isViewOpen ? <div className={classes.damageImageViewer}>
        <Button
          onClick={() => setIsViewOpen(false)}
          variant="contained"
          color="primary"
          className={classes.damageImageViewerCloseButton}>Zamknij</Button>
        <div className={classes.damageImageViewerContent}>
          <img src={"data:image/jpeg;base64," + image} alt="" className={classes.damageImage}/>
        </div>
      </div> : <></>}

    </div>);
};

export default compose(
  withStyles(useStyles),
)(CarDamageImage);

CarDamageImage.propTypes = {
  classes: PropTypes.object,
  damage: PropTypes.object,
  onDamageImageChange: PropTypes.func,
};
